"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowPropertiesMergerDivId = exports.TableRowPropertiesMergerHorizontalAlignment = exports.TableRowPropertiesMergerCantSplit = exports.TableRowPropertiesMergerCellSpacing = exports.TableRowPropertiesMerger = void 0;
var tslib_1 = require("tslib");
var table_row_properties_1 = require("../properties/table-row-properties");
var table_base_structures_1 = require("../secondary-structures/table-base-structures");
var table_properties_merger_1 = require("./table-properties-merger");
var table_properties_merger_base_1 = require("./table-properties-merger-base");
var TableRowPropertiesMerger = (function (_super) {
    tslib_1.__extends(TableRowPropertiesMerger, _super);
    function TableRowPropertiesMerger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowPropertiesMerger.prototype.getContainerFromConditionalStyle = function (condStyle) {
        return condStyle.tableRowProperties;
    };
    TableRowPropertiesMerger.prototype.canUseValue = function (props) {
        return !!(props.mask & this.getPropertyMask());
    };
    TableRowPropertiesMerger.prototype.getCondTableStyleFormattingListForThisContainer = function () {
        return TableRowPropertiesMerger.conditionalTableStyleFormattingPriority;
    };
    TableRowPropertiesMerger.prototype.getNotMergedProperty = function () {
        return new table_properties_merger_base_1.TableMergerNotMergedPropertyResult(false, null);
    };
    TableRowPropertiesMerger.conditionalTableStyleFormattingPriority = [
        table_base_structures_1.ConditionalTableStyleFormatting.FirstRow,
        table_base_structures_1.ConditionalTableStyleFormatting.LastRow,
        table_base_structures_1.ConditionalTableStyleFormatting.OddRowBanding,
        table_base_structures_1.ConditionalTableStyleFormatting.EvenRowBanding,
        table_base_structures_1.ConditionalTableStyleFormatting.WholeTable,
    ];
    return TableRowPropertiesMerger;
}(table_properties_merger_base_1.TablePropertiesMergerBase));
exports.TableRowPropertiesMerger = TableRowPropertiesMerger;
var TableRowPropertiesMergerCellSpacing = (function (_super) {
    tslib_1.__extends(TableRowPropertiesMergerCellSpacing, _super);
    function TableRowPropertiesMergerCellSpacing(model, table, tablePropertiesException) {
        var _this = _super.call(this) || this;
        _this.tablePropertiesException = tablePropertiesException;
        _this.model = model;
        _this.table = table;
        return _this;
    }
    TableRowPropertiesMergerCellSpacing.prototype.getPropertyFromContainer = function (container) {
        return container.cellSpacing;
    };
    TableRowPropertiesMergerCellSpacing.prototype.getPropertyMask = function () {
        return table_row_properties_1.TableRowPropertiesMask.UseCellSpacing;
    };
    TableRowPropertiesMergerCellSpacing.prototype.getNotMergedProperty = function () {
        return new table_properties_merger_1.TablePropertiesMergerCellSpacing().getTableNotMergedProperty(this.tablePropertiesException);
    };
    TableRowPropertiesMergerCellSpacing.prototype.actionBeforeDefaultValue = function () {
        this.result = new table_properties_merger_1.TablePropertiesMergerCellSpacing().getProperty(this.table.properties, this.table.style, table_base_structures_1.ConditionalTableStyleFormatting.WholeTable, this.model.defaultTableProperties);
        return true;
    };
    return TableRowPropertiesMergerCellSpacing;
}(TableRowPropertiesMerger));
exports.TableRowPropertiesMergerCellSpacing = TableRowPropertiesMergerCellSpacing;
var TableRowPropertiesMergerCantSplit = (function (_super) {
    tslib_1.__extends(TableRowPropertiesMergerCantSplit, _super);
    function TableRowPropertiesMergerCantSplit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowPropertiesMergerCantSplit.prototype.getPropertyFromContainer = function (container) {
        return container.cantSplit;
    };
    TableRowPropertiesMergerCantSplit.prototype.getPropertyMask = function () {
        return table_row_properties_1.TableRowPropertiesMask.UseCantSplit;
    };
    return TableRowPropertiesMergerCantSplit;
}(TableRowPropertiesMerger));
exports.TableRowPropertiesMergerCantSplit = TableRowPropertiesMergerCantSplit;
var TableRowPropertiesMergerHorizontalAlignment = (function (_super) {
    tslib_1.__extends(TableRowPropertiesMergerHorizontalAlignment, _super);
    function TableRowPropertiesMergerHorizontalAlignment(tablePropertiesException) {
        var _this = _super.call(this) || this;
        _this.tablePropertiesException = tablePropertiesException;
        return _this;
    }
    TableRowPropertiesMergerHorizontalAlignment.prototype.getPropertyFromContainer = function (container) {
        return container.tableRowAlignment;
    };
    TableRowPropertiesMergerHorizontalAlignment.prototype.getPropertyMask = function () {
        return table_row_properties_1.TableRowPropertiesMask.UseTableRowAlignment;
    };
    TableRowPropertiesMergerHorizontalAlignment.prototype.actionBeforeDefaultValue = function () {
        this.result = null;
        return true;
    };
    TableRowPropertiesMergerHorizontalAlignment.prototype.getNotMergedProperty = function () {
        return new table_properties_merger_1.TablePropertiesMergerHorizontalAlignment().getTableNotMergedProperty(this.tablePropertiesException);
    };
    return TableRowPropertiesMergerHorizontalAlignment;
}(TableRowPropertiesMerger));
exports.TableRowPropertiesMergerHorizontalAlignment = TableRowPropertiesMergerHorizontalAlignment;
var TableRowPropertiesMergerDivId = (function (_super) {
    tslib_1.__extends(TableRowPropertiesMergerDivId, _super);
    function TableRowPropertiesMergerDivId() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowPropertiesMergerDivId.prototype.getPropertyFromContainer = function (container) {
        return container.divId;
    };
    TableRowPropertiesMergerDivId.prototype.getPropertyMask = function () {
        return table_row_properties_1.TableRowPropertiesMask.UseDivId;
    };
    TableRowPropertiesMergerDivId.prototype.actionBeforeDefaultValue = function () {
        this.result = null;
        return true;
    };
    return TableRowPropertiesMergerDivId;
}(TableRowPropertiesMerger));
exports.TableRowPropertiesMergerDivId = TableRowPropertiesMergerDivId;
